import CustomLabelComponent from '../../../pages/Dashboard/CustomLabelComponent';

export default CustomLabelComponent;